export default "__VITE_PUBLIC_ASSET__0afaebcc__"